import React, { useState ,useEffect} from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import Select from "react-select";

import moment from "moment";
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isDriver, setBranch] = useState(props ? props.driverRec : {});
  const [selectedCountry, setSelectedCounty] = useState({});
  const [selectedState, setSelectedState] = useState({});
  const [countryOptions, setOptionCounty] = useState({});
  const [statesOption, setOptionStates] = useState([]); // Initialize as an array

  useEffect(() => {
    const fetchData = async () => {
      const country = await trasportApi.fetchAllCountry();
      const stateList = await trasportApi.fetchAllStates();
      if (country && country.length) {
        let ar = [];
        country.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });

        if (props?.driverRec) {
          let acc = ar.filter((acc) => acc.value === props.driverRec.country_id);
          setSelectedCounty(acc);
        }

        setOptionCounty(ar);
      } else {
        setOptionCounty([]);
      }

      if (stateList && stateList.length) {
        let ar = [];
        stateList.forEach((item) => {
          ar.push({ value: item.id, label: item.state_name });
        });

        if (props?.driverRec) {
          let acc = ar.filter((acc) => acc.value === props.driverRec.state_id);
          setSelectedState(acc);
        }
        setOptionStates(ar);
      } else {
        setOptionStates([]);
      }
    };

    fetchData();
  }, []);
 
  const checkRequiredFields = () => {
    if (
      isDriver.country_id &&
      isDriver.country_id.trim() !== "" &&
      isDriver.state_id &&
      isDriver.state_id.trim() !== "" &&
      isDriver.city_name &&
      isDriver.city_name.trim() !== ""
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};

    if (isDriver.id) {
      result2 = await trasportApi.saveCity(isDriver);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createCity(isDriver);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handlefinancialYear = (e) => {
    setSelectedCounty(e);
    setBranch({ ...isDriver, country_id: e.value });
  };

  const handleState = (e) => {
    setSelectedState(e);
    setBranch({ ...isDriver, state_id: e.value });
  };

  const handleDriver  = async (e) => {
    setBranch({ ...isDriver, [e.target.name]: e.target.value });
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          City
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Country
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Country"
                      value={selectedCountry}
                      onChange={handlefinancialYear}
                      options={countryOptions}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Country.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    State
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select State"
                      value={selectedState}
                      onChange={handleState}
                      options={statesOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select State.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        City
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="city_name"
                        placeholder="Enter City Name"
                        value={isDriver.city_name}
                        onChange={handleDriver}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
